import React, { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const SITE_URL = "https://sliz.fr";

const ContentContext = createContext(null);

async function fetchContent() {
  const res = await fetch(`${API}/content`);
  if (!res.ok) throw new Error("contenu indisponible");
  return res.json();
}

export function ContentProvider({ children }) {
  const { data, isLoading, refetch } = useQuery({ queryKey: ["content"], queryFn: fetchContent, staleTime: 30_000 });
  return <ContentContext.Provider value={{ data, isLoading, refetch }}>{children}</ContentContext.Provider>;
}

export function useContent() {
  return useContext(ContentContext);
}

export function adminHeaders() {
  const token = localStorage.getItem("sliz_admin_token") || "";
  return { "Content-Type": "application/json", Authorization: `Bearer ${token}` };
}

// Écriture admin : lève une erreur explicite (code HTTP + message réel du serveur)
// au lieu de laisser passer un 401/403/422 en silence.
export async function adminWrite(path, { method = "PUT", body } = {}) {
  const res = await fetch(`${API}${path}`, {
    method,
    headers: adminHeaders(),
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (res.ok) return data;
  const d = data && data.detail;
  const detail = typeof d === "string" ? d : d ? JSON.stringify(d) : "";
  let msg = `HTTP ${res.status}`;
  if (detail) msg += ` : ${detail}`;
  if (res.status === 401) msg += " — session admin expirée ou jeton invalide : déconnectez-vous puis reconnectez-vous.";
  else if (res.status === 403) msg += " — droits insuffisants.";
  const err = new Error(msg);
  err.status = res.status;
  throw err;
}
